import { useState, useEffect } from "react";
import useApi from "../../../../../utils/api-manager/Helper/useApi";
import {useToastHandler} from "../../../../common/ToastHandler"
const SalesReportController = () => {
  const { Get, Post } = useApi();
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [selectedVendor, setSelectedVendor] = useState("");
  const [vendors, setVendors] = useState([]);
  const [reportData, setReportData] = useState([]);
  const [products, setProducts] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState("");
  const [selectedInvoice, setSelectedInvoice] = useState("");
  const [allproductbyvendor, setallProductsByVendor] = useState("");
  const [perProductProfit, setPerProductProfit] = useState("");
  const [perProductId, setPerProductId] = useState("");
  const [vendorProfitDetails, setVendorProfitDetails] = useState("");
  const [invoiceDetails, setinvoiceDetails] = useState([]);
  const [filteredInvoices, setFilteredInvoices] = useState([]);
  const [singleInvoiceProfit, setSingleInvoiceProfit] = useState();
  const [loading, setLoading] = useState(false);
 const {handleToast} = useToastHandler();
  useEffect(() => {
    fetchVendors();
  }, []);

  useEffect(() => {
    if (selectedProduct && invoiceDetails.length > 0) {
      const matchingInvoices = invoiceDetails
        .flat()
        .filter((invoice) =>
          perProductId.some(
            (product) =>
              product.product_id === selectedProduct &&
              vendorProfitDetails.invoice_profits.some(
                (profit) => profit.invoice_id === invoice.invoice_id
              )
          )
        );
      setFilteredInvoices(matchingInvoices);
    } else {
      setFilteredInvoices([]);
    }
  }, [selectedProduct, invoiceDetails, perProductId, vendorProfitDetails]);

  const fetchVendors = async () => {
    try {
      const response = await Get("vendorDepartmentData");
      setVendors(response);
    } catch (error) {
      console.error("Error fetching vendors:", error);

      handleToast({
        type:"ERROR",
        message:"Error fetching vendors"
      })
    }
  };

  const fetchProductsByVendor = async (vendorId) => {

  };

  const handleVendorChange = (vendorId) => {
    setSelectedVendor(vendorId);
    setSelectedProduct("");
    setSelectedInvoice("");
    if (vendorId) {
      fetchProductsByVendor(vendorId);
    } else {
      setProducts([]);
    }
  };

  const handleProductChange = (productId) => {
    setSelectedProduct(productId);
    setSelectedInvoice("");
  };

  const handleInvoiceChange = (invoiceId) => {
    setSelectedInvoice(invoiceId);

    if (invoiceId && allproductbyvendor) {
      const filteredData = {
        ...allproductbyvendor,
        product_profit_details_all_products:
          allproductbyvendor.product_profit_details_all_products.filter(
            (product) =>
              product.invoice_details.some(
                (invoice) => invoice.invoice_id === invoiceId
              )
          ),
      };
      setallProductsByVendor(filteredData);
    }
  };

  const handleFetchReport = async () => {
    if (!startDate || !endDate || !selectedVendor) {

      handleToast({
        type:"ERROR",
        message:"Please select start date, end date, and vendor."
      })
      return;
    }

    const payload = {
      vendor_id: selectedVendor,
      start_date: startDate,
      end_date: endDate,
    };
    setLoading(true);
    try {
      const response = await Post("reportForStore", payload);

      setinvoiceDetails(
        response.data.all_products_by_vendor.product_profit_details_all_products.map(
          (product) => product.invoice_details
        )
      );

      const allProductsByVendorData = response.data.all_products_by_vendor;
      const allprofitProductData =
        response.data.all_products_by_vendor
          .product_profit_details_all_products;

      const productData = allprofitProductData.map((product) => ({
        product_id: product.product_id,
        product_name: product.product_name,
      }));

      setPerProductId(productData);

      const profitDetailsArray = allprofitProductData.map((product) => ({
        productId: product.product_id,
        productName: product.product_name,
        profit: product.profit,
        totalCost: product.total_cost,
        profitPercentage: product.profit_percentage,
      }));

      setVendorProfitDetails(response.data.vendor_profit_detail);

      setSingleInvoiceProfit(
        response.data.vendor_profit_detail.invoice_profits
      );
      setPerProductProfit(profitDetailsArray);
      setallProductsByVendor(allProductsByVendorData);
      setReportData(response);
      setProducts(productData);
    } catch (error) {
      console.error("Error fetching report:", error);

      handleToast({
        type:"ERROR",
        message:"Failed to fetch report"
      })
    } finally {
      setLoading(false);
    }
  };

  return {
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    selectedVendor,
    handleVendorChange,
    vendors,
    products,
    selectedProduct,
    handleProductChange,
    selectedInvoice,
    handleInvoiceChange,
    filteredInvoices,
    reportData,
    handleFetchReport,
    allproductbyvendor,
    perProductProfit,
    perProductId,
    invoiceDetails,
    vendorProfitDetails,
    singleInvoiceProfit,
    loading,
  };
};

export default SalesReportController;